import history from "../../../history";
import API from "../../../utils/endpoints";
import { fetchExperiencesList } from "../experience/actions";
import * as types from "./actionType";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const errorMessage = {
  status: 400,
  message: "Something went wrong",
};

function fetchigToursList() {
  return {
    type: types.FETCH_TOURS_LIST,
  };
}

function fetchigToursListSuccess(payload, count, pendingCount) {
  return {
    type: types.FETCH_TOURS_LIST_SUCCESS,
    payload,
    count,
    pendingCount,
  };
}

function fetchigToursListFailed() {
  return {
    type: types.FETCH_TOURS_LIST_FAILED,
  };
}

function fetchingTourUpdatedDetails() {
  return {
    type: types.TOURS_UPDATE_DETAILS,
  };
}

function fetchingTourUpdatedDetailsSuccess(payload, count) {
  return {
    type: types.TOURS_UPDATE_DETAILS_SUCCESS,
    payload,
    count,
  };
}

function fetchingTourUpdatedDetailsFailed() {
  return {
    type: types.TOURS_UPDATE_DETAILS_FAILED,
  };
}

function fetchigToursDetails() {
  return {
    type: types.FETCH_TOURS_DETAILS,
  };
}

function fetchigToursDetailsSuccess(payload) {
  return {
    type: types.FETCH_TOURS_DETAILS_SUCCESS,
    payload,
  };
}

function fetchigToursDetailsFailed() {
  return {
    type: types.FETCH_TOURS_DETAILS_FAILED,
  };
}

function creatingTour() {
  return {
    type: types.CREATE_TOUR,
  };
}

function creatingTourSuccess(payload, count) {
  return {
    type: types.CREATE_TOUR_SUCCESS,
    payload,
    count,
  };
}

function creatingTourFailed() {
  return {
    type: types.CREATE_TOUR_FAILED,
  };
}

function updatingTourInfo() {
  return {
    type: types.UPDATE_TOUR_INFO,
  };
}

function updatingTourInfoSuccess(payload, count) {
  return {
    type: types.UPDATE_TOUR_INFO_SUCCESS,
    payload,
    count,
  };
}

function updatingTourInfoFailed() {
  return {
    type: types.UPDATE_TOUR_INFO_FAILED,
  };
}

function uploadUrlRequest() {
  return {
    type: types.UPLOAD_URL,
  };
}

function uploadUrlSuccess(payload) {
  return {
    type: types.UPLOAD_URL_SUCCESS,
    payload,
  };
}

function uploadUrlFailed() {
  return {
    type: types.UPLOAD_URL_FAILED,
  };
}

function readUrlRequest() {
  return {
    type: types.READ_URL,
  };
}

function readUrlSuccess(payload) {
  return {
    type: types.READ_URL_SUCCESS,
    payload,
  };
}

function readUrlFailed() {
  return {
    type: types.READ_URL_FAILED,
  };
}

function uploadBinaryUrlRequest() {
  return {
    type: types.UPLOAD_BINARY_URL,
  };
}

function uploadBinaryUrlSuccess(payload) {
  return {
    type: types.UPLOAD_BINARY_URL_SUCCESS,
    payload,
  };
}

function uploadBinaryUrlFailed() {
  return {
    type: types.UPLOAD_BINARY_URL_FAILED,
  };
}

export const fetchToursList = (payload, data) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchigToursList());
  try {
    let response = await api.get(
      `${API.fetchToursList}?status=${payload.status}&page=${
        payload.page
      }&limit=${payload.limit}&category=${payload.category}&startDate=${
        payload.startDate
      }&endDate=${payload.endDate}&country=${
        payload.country ? payload.country : ""
      }`
    );

    if (response.data.code === 200) {
      dispatch(
        fetchigToursListSuccess(
          response.data.data.wanderlustData,
          response.data.data.count,
          response.data.data.pendingCount
        )
      );
      // toast.error(response.data.message);
    } else {
      dispatch(fetchigToursListFailed());
      if (!data) {
        toast.error(response.data.message);
      }
    }
  } catch (error) {
    dispatch(fetchigToursListFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const updateToursDetails = (payload, wanderlustId, callback) => async (
  dispatch,
  getState,
  api
) => {
  // dispatch(createPartner());
  try {
    let response = await api.post(
      `${API.updateModeration}?wanderlustId=${wanderlustId} `,
      payload
    );

    if (response.data.code === 200) {
      callback && callback();
      toast.error(response.data.message);
    } else {
      // dispatch(createPartnerFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    // dispatch(createPartnerFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const approveRejectUpdatedTourDetails = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  // dispatch(createPartner());
  try {
    let response = await api.put(API.updateModeration, payload);

    if (response.data.code === 200) {
      dispatch(fetchUpdatedToursData(payload.wanderlustId));
      // dispatch(createPartnerSuccess(response.data.data));
      toast.error(response.data.message);
      callback && callback();
      // history.push("/partner/list");
    } else {
      // dispatch(createPartnerFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    // dispatch(createPartnerFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const deleteUpdatedTourDetails = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  // dispatch(createPartner());
  try {
    let response = await api.delete(
      `${API.updateModeration}?wanderlustId=${payload.wanderlustId}&key=${payload.key}`
    );
    if (response.data.code === 200) {
      dispatch(fetchUpdatedToursData(payload.wanderlustId));
      // dispatch(createPartnerSuccess(response.data.data));
      toast.error(response.data.message);
      callback && callback();
      // history.push("/partner/list");
    } else {
      // dispatch(createPartnerFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    // dispatch(createPartnerFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const fetchUpdatedToursData = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingTourUpdatedDetails());
  try {
    let response = await api.get(
      `${API.updateModeration}?wanderlustId=${payload}`
    );
    if (response.data.code === 200) {
      dispatch(fetchingTourUpdatedDetailsSuccess(response.data.data));
    } else {
      dispatch(fetchingTourUpdatedDetailsFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(fetchingTourUpdatedDetailsFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const fetchToursDetail = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchigToursDetails());
  try {
    let response = await api.get(
      `${API.fetchToursDetail}?wanderlustId=${payload}`
    );

    if (response.data.code === 200) {
      dispatch(fetchigToursDetailsSuccess(response.data.data));
      // toast.error(response.data.message);
    } else {
      dispatch(fetchigToursDetailsFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(fetchigToursDetailsFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const createTour = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(creatingTour());
  try {
    let response = await api.post(API.createTours, payload);
    if (response.data.code === 200) {
      dispatch(creatingTourSuccess(response.data.data));
      callback && callback();
      toast.error(response.data.message);
    } else {
      dispatch(creatingTourFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(creatingTourFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const deleteTourInfo = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  // dispatch(deletingTourInfo());

  console.log(payload);

  try {
    let response = await api.delete(
      `${API.deleteTour}?wanderlustId=${payload.wanderlustId}&status=${payload.status}&rejectionReason=${payload.rejectionReason}`
    );
    if (response.data.code === 200) {
      // dispatch(deletingTourInfoSuccess(response.data.data));
      callback && callback();
      toast.error(response.data.message);
    } else {
      // dispatch(deletingTourInfoFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    // dispatch(deletingTourInfoFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const updateTourInfo = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(updatingTourInfo());

  console.log(payload);

  try {
    let response = await api.put(API.updateTour, payload);
    if (response.data.code === 200) {
      dispatch(updatingTourInfoSuccess(response.data.data));
      callback && callback();
      // history.push("/event/list");
      toast.error(response.data.message);
    } else {
      dispatch(updatingTourInfoFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(updatingTourInfoFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const ApproveRejectTour = (payload) => async (
  dispatch,
  getState,
  api
) => {
  // dispatch(createPartner());
  try {
    let response = await api.post(API.fetchToursList, payload);

    if (response.data.code === 200) {
      // dispatch(createPartnerSuccess(response.data.data));
      toast.error(response.data.message);
      history.push("/moderation/tours");
    } else {
      // dispatch(createPartnerFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    // dispatch(createPartnerFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const TourGalleryModeration = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  // dispatch(createPartner());
  try {
    let response = await api.post(`${API.galleryModeration} `, payload);

    if (response.data.code === 200) {
      callback && callback();
      toast.error(response.data.message);
    } else {
      // dispatch(createPartnerFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    // dispatch(createPartnerFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const uploadUrl = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(uploadUrlRequest());
  try {
    let response = await api.post(API.uploadUrl, {
      name: payload.name,
      extension: payload.type.slice(payload.type.lastIndexOf("/") + 1),
      category: "tours",
    });
    if (response.data.code === 200) {
      dispatch(uploadUrlSuccess(response.data.data));
      dispatch(uploadBinaryUrl(response.data.data, payload, callback));
    } else {
      dispatch(uploadUrlFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(uploadUrlFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const uploadBinaryUrl = (data, payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(uploadBinaryUrlRequest());
  try {
    let response = await axios.put(data.uploadURL, payload, {
      headers: {
        "x-ms-blob-type": "BlockBlob",
      },
    });
    console.log("res", response.status);
    if (response.status === 201) {
      dispatch(uploadBinaryUrlSuccess(response.data.data));
      dispatch(readUrl(data.filePath, callback));
    } else {
      dispatch(uploadBinaryUrlFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(uploadBinaryUrlFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const readUrl = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(readUrlRequest());
  try {
    let response = await api.get(`${API.readUrl}?path=${payload}`);
    if (response.data.code === 200) {
      let prevData = getState().VinLookup.documentRead;
      let newData = [...prevData, response.data.data.blobPath];
      dispatch(readUrlSuccess(newData));
      callback && callback(response.data.data.blobPath);
    } else {
      dispatch(readUrlFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(readUrlFailed(errorMessage));
    toast.error(errorMessage);
  }
};
